import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError as observableThrowError, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TaxpayerRegistrationService {

  private BASE_URL:string = window["cfgApiBaseUrl"];
  private TCC_DATA_URL:string = this.BASE_URL+"tccdata";
  private TAXPAYER_DATA_URL:string = this.BASE_URL+"taxpayerdata/";
  private TAXPAYER_ENTERPRISE_URL:string = this.BASE_URL+"taxpayerdata/enterprise/";

  private _taxpayerEnterprise: Array<any>;
  
 
  constructor(private http : HttpClient) { }

  public get taxpayerEnterprise(): Array<any> {
    return this._taxpayerEnterprise;
  }

  register(taxpayer : ITaxpayer){
    return this.http.post<any>(this.TCC_DATA_URL, taxpayer);
  }

  getDetails(tin:string){
    return this.http.get<any>(this.TAXPAYER_DATA_URL+tin);
  }

  getEnterprises(tin:string):Observable<any>{
    return this.http.get<any>(this.TAXPAYER_ENTERPRISE_URL+tin);
  }

  errorHandler(error : HttpErrorResponse){
     return observableThrowError(error.message || "Server Error");
   }
}
